import adminRepo from '@/api/core/adminRepository';
import videoRepo from '@/api/core/videoRepository';
import tmdbRepo from '@/api/core/tmdbRepository';
import util from "@/util";

const repositories = {
    admin: adminRepo,
    video: videoRepo,
    tmdb: tmdbRepo,
}

export class RepositoryFactory  {
    static get(name) {
        return util.get(repositories, name, null);
    }
}